import "./News.css";


import Navbar from "../../component/Navbar/Navbar";
import Footer from "../../component/Footer/Footer";

function News() {
  return (
    <>
    

      <Navbar />

      <main className="news-page">

        <div className="news-container">

          <h1>
            News &amp; Events
          </h1>

          <p>
            Latest news and community activities.
          </p>


          <div className="news-page-grid">

            <article>
              <span>
                NEWS
              </span>

              <h2>
                New Membership Drive Launched
              </h2>

              <p>
                APNB Seva Samithi has launched a
                new membership drive.
              </p>
            </article>


            <article>
              <span>
                EVENT
              </span>

              <h2>
                Education Support Program
              </h2>

              <p>
                Education support activities for
                deserving families and students.
              </p>
            </article>


            <article>
              <span>
                NEWS
              </span>

              <h2>
                Annual General Meeting
              </h2>

              <p>
                Annual activities and community
                development plans were discussed.
              </p>
            </article>

          </div>

        </div>

      </main>

      <Footer />
    </>
  );
}

export default News;